import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AddressAutocomplete from "@/components/AddressAutocomplete";
import DatePickerAU from "@/components/DatePickerAU";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { RotateCcw } from "lucide-react";

const mk = (a) => a ? ({ ...a, label: a.label || [a.business, a.line1, a.city, a.postcode].filter(Boolean).join(", ") }) : null;

export default function RebookDialog({ order, open, onOpenChange }) {
  const navigate = useNavigate();
  const [dropoff, setDropoff] = useState(null);
  const [date, setDate] = useState("");

  useEffect(() => {
    if (order) { setDropoff(mk(order.dropoff)); setDate(""); }
  }, [order]);

  if (!order) return null;
  const go = () => {
    navigate("/book", {
      state: { rebook: { pickup: order.pickup, dropoff, items: order.items, service: order.service, scheduled_date: date } },
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="rebook-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Rebook {order.tracking_number}</DialogTitle>
          <DialogDescription>
            Same pickup ({order.pickup.city}) and items — tweak just the drop-off or date if it's a regular run, then continue to the quote.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <AddressAutocomplete label="Drop-off address" value={dropoff} onSelect={setDropoff} testid="rebook-dropoff" />
          <div className="space-y-1.5">
            <Label>Pickup date (optional)</Label>
            <DatePickerAU value={date} onChange={setDate} minToday placeholder="Any day" testid="rebook-date" />
          </div>
        </div>
        <DialogFooter>
          <Button onClick={go} disabled={!dropoff} data-testid="rebook-continue-button" className="gap-2 bg-kilted-green hover:bg-kilted-greenLight">
            <RotateCcw className="h-4 w-4" /> Continue to quote
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
